import classes from './Label.module.css';

const Label = ({ text, styles, colors = {} }) => {

    return (
        <span className={classes.label}
              style={{
                  backgroundColor: colors.secondary,
                  borderColor: colors.primary,
                  color: colors.primary,
                  ...styles
              }}>
        {text}
    </span>);
}

export default Label;
